import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import {
  DuperbrowseHostInitOptions,
  ActiveDuperbrowseStream,
  DuperbrowseItemId,
  DuperbrowseStream,
  DuperbrowseItemSchema,
  DuperbrowseItem,
} from './types';
import { PapiDeviation } from '@wix/da-papi-types';

export const initializeDuperbrowse = createAction(
  `${actionKey}/CONFIGURE`,
  (options: DuperbrowseHostInitOptions) => options
);

export const loadDuperbrowse = createAction(
  `${actionKey}/LOAD`,
  (itemId: DuperbrowseItemId, stream: DuperbrowseStream) => ({ itemId, stream })
);

export const openDuperbrowse = createAction(
  `${actionKey}/OPEN`,
  (itemId: DuperbrowseItemId, stream: DuperbrowseStream) =>
    ({
      ...stream,
      currentOpenItem: itemId,
      parent: {
        ...stream.parent,
        url: window.location.href,
      },
    }) as ActiveDuperbrowseStream
);

export const openDuperbrowseWithEntities = createAction(
  `${actionKey}/OPEN`,
  (itemId: DuperbrowseItemId, stream: DuperbrowseStream) =>
    ({
      ...stream,
      currentOpenItem: itemId,
      parent: {
        ...stream.parent,
        url: window.location.href,
      },
    }) as ActiveDuperbrowseStream,
  (_, __, entities) => ({ entities })
);

export const exitDuperbrowse = createAction(`${actionKey}/EXIT`, () => null);
export const exitDuperbrowseDone = createAction(
  `${actionKey}/EXIT_DONE`,
  () => null
);
export const exitDuperbrowseResorationTimeout = createAction(
  `${actionKey}/EXIT_RESTORE_TIMEOUT`,
  () => null
);
export const moveNext = createAction(`${actionKey}/NEXT`, () => null);
export const movePrev = createAction(`${actionKey}/PREV`, () => null);
export const unloadDuperbrowseItem = createAction(
  `${actionKey}/UNLOAD_DUPERBROWSE_ITEM`,
  (deviation: DuperbrowseItem | undefined) => ({ deviation })
);
export const setCurrentItem = createAction(
  `${actionKey}/SET_CURRENT_ITEM`,
  (itemId: DuperbrowseItemId) => ({ itemId })
);
export const setCurrentStreamByStackIndex = createAction(
  `${actionKey}/SET_CURRENT_STREAM_BY_STACK_INDEX`,
  (indexInStack: number, itemId: DuperbrowseItemId) => ({
    indexInStack,
    itemId,
  })
);
export const shutdownDuperbrowse = createAction(
  `${actionKey}/SHUTDOWN`,
  () => null
);

export const loadDuperbrowseItem = createAction(
  `${actionKey}/LOAD_ITEM`,
  (
    itemId: DuperbrowseItemId,
    itemSchema: DuperbrowseItemSchema,
    preloadDirection: 'next' | 'prev' | undefined
  ) => ({
    itemId,
    itemSchema,
    preloadDirection,
  })
);

export const updateBiMetadata = createAction(
  `${actionKey}/UPDATE_BI`,
  (biMetadata: string, deviation: PapiDeviation) => ({
    biMetadata,
    deviation,
  })
);
